var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0144 2.69821L7.56616 0.382027C7.30576 0.135662 6.96491 0 6.60645 0H1.94531C1.17529 0 0.548828 0.626463 0.548828 1.39648V11.6035C0.548828 12.3735 1.17529 13 1.94531 13H9.05469C9.82471 13 10.4512 12.3735 10.4512 11.6035V3.71267C10.4512 3.33056 10.292 2.9608 10.0144 2.69821ZM9.2746 3.04688H7.37891C7.3089 3.04688 7.25195 2.98992 7.25195 2.91992V1.13334L9.2746 3.04688ZM9.05469 12.2383H1.94531C1.5953 12.2383 1.31055 11.9535 1.31055 11.6035V1.39648C1.31055 1.04647 1.5953 0.761719 1.94531 0.761719H6.49023V2.91992C6.49023 3.40994 6.88889 3.80859 7.37891 3.80859H9.68945V11.6035C9.68945 11.9535 9.4047 12.2383 9.05469 12.2383Z",
    fill: "#237FB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.c34643012db8cf2c092a196be6131011.svg";
export { ForwardRef as ReactComponent };